import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.TEMP_PONS_MANAGE_PROCEDURES}`,
            render: () => import("../../Pages/Nursing/TempPONS/ManageProcedures/ManageProcedures.svelte"),
            title: "Manage Temp PONS Procedures"
        }
    ]
};

export default routerConfig;

